import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"


const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getAllBannerAction = createAsyncThunk(
    'get-all-banner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/pwa/api/get-all-banner`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAllBannerSlice = createSlice({
    name: 'get-all-banner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllBannerAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getAllBannerAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getAllBannerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getAllBannerReducer = getAllBannerSlice.reducer